import Icon from 'vue-awesome/components/Icon'

Icon.register({
  perm_scan_wifi_outlined: {
    paths: [
      {
        d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zM2.92 7.65C5.8 5.85 8.74 5 12 5c3.25 0 6.18.85 9.08 2.67L12 18.83 2.92 7.65z'
      },
      {
        d: 'M11 10h2v6h-2zm0-4h2v2h-2z'
      }
    ],
    width: '24',
    height: '24'
  }
})
